export default __webpack_public_path__ + "static/media/404.1796faf6.png";